import { useDispatch, useSelector } from 'react-redux'
import { State } from 'src/state'
import { patchCurrentUser } from 'src/state/users'
import { LanguageCode, UserPatchType } from '@meniudigital/shared'
import { IS_DESKTOP_OR_TABLET } from '../..'
import Setting from '../Setting'

export default function CustomMessageSetting() {
  const dispatch = useDispatch()
  const { user } = useSelector((state: State) => state.users)

  if (!user) {
    return null
  }

  const toggleVisibility = () => {
    dispatch(
      patchCurrentUser({
        type: UserPatchType.CustomMenuMessage,
        data: { ...(user.customMenuMessage || {}), isVisible: !user.customMenuMessage?.isVisible },
      }),
    )
  }

  const updateMessage = (value: string) => {
    dispatch(
      patchCurrentUser({
        type: UserPatchType.CustomMenuMessage,
        data: { ...(user.customMenuMessage || {}), message: { [LanguageCode.Romanian]: value } },
      }),
    )
  }

  return (
    <>
      <div className="setting-question">Dorești afișarea unui mesaj personalizat pe meniu?</div>
      <Setting
        title={`Mesaj ${IS_DESKTOP_OR_TABLET ? 'Personalizat ' : ''}pe Meniu`}
        iconPath="/icons/message.png"
        isEnabled={user?.customMenuMessage?.isVisible}
        onToggle={toggleVisibility}
        toggleTexts={{ on: 'Vizibil', off: '' }}
        body={
          <textarea
            placeholder="e.g. Echipa Demo Bistro vă urează o primăvară frumoasă! 🎉🐰💐"
            defaultValue={user?.customMenuMessage?.message?.[LanguageCode.Romanian] || ''}
            onBlur={e => updateMessage(e.target.value)}
          />
        }
        infoText="Mesajul va fi afișat sub poza de copertă, înaintea primei categorii din meniu."
        withBullet
      />
    </>
  )
}
